import React from 'react';
import SEO from '../components/seo';
import { Link } from 'gatsby';
import { graphql } from 'gatsby';
// import LemochloButton from '../components/lemochloButton';
import Statement from '../components/toppage/statement';
import HealthcareIntro from '../components/toppage/healthcareIntro';
// import introProjects from '../components/toppage/introProjects';
import HorizontalScroll from '../components/toppage/horizontalScroll';
import EarthRotate from '../components/toppage/earthRotate';
// import HorizontalScroll__Comunity from '../components/toppage/horizontalScroll__Comunity';
// import HorizontalScroll__Product from '../components/toppage/horizontalScroll__Product';
// import HorizontalScroll__Health from '../components/toppage/horizontalScroll__Health';
import MemberReveal from '../components/toppage/memberReveal';
import BlogList from '../components/toppage/blogList';
// import ScrollbarEffect from '../components/Scrollbar';

const IndexPage = ({ data }) => {
  return (
    <>
      <SEO
        title="Silencer Inc. | Face Yourself"
        description="株式会社サイレンサー。「地球上全人類の健康をアップデート」をVISIONに掲げ、人類が自分と向き合う為の健康革命を進めています。"
      />
      {/* <ScrollbarEffect /> */}
      <div id="viewport">
        {/* <ProductList data={data} /> */}
        {/* <ProjectIdea img={data.projectIdea.childImageSharp.fluid} /> */}
        <section className="main--visual">
          {/* <svg id="svg">
          <defs>
            <filter id="disFilter">
              <feTurbulence
                type="turbulence"
                baseFrequency="0.01"
                numOctaves="3"
                seed="1"
                result="turbulence"
              >
                <animate
                  attributeName="baseFrequency"
                  values="0.001;0.007;0.001;"
                  dur="30s"
                  begin="0"
                  repeatCount="indefinite"
                />
              </feTurbulence>
              <feDisplacementMap
                in="SourceGraphic"
                in2="turbulence"
                scale="30"
                xChannelSelector="R"
                yChannelSelector="B"
                result="displacement"
              />
            </filter>
          </defs>
          <g id="background">
            <image
              xlinkHref={mainvisual}
              x="0"
              y="0"
              height="100%"
              width="100%"
              preserveAspectRatio="xMidYMid slice"
            />
          </g>
        </svg> */}
          <div className="main--visual__wrap">
            <div className="main--visual__box">
              <h1 className="main--visual__title">
                {/* <span>Silencer Inc.</span> */}
                <span>
                  <svg
                    version="1.1"
                    id="layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 86.4 89.6"
                    style={{ enableBackground: 'new 0 0 86.4 89.6' }}
                  >
                    <style
                      type="text/css"
                      dangerouslySetInnerHTML={{
                        __html: '\n    .st0{fill:#231815;}\n  ',
                      }}
                    />
                    <g id="XMLID_17_">
                      <path
                        id="XMLID_21_"
                        className="st0"
                        d="M55.9,20.1c-1.4-0.5-3,0.2-3.5,1.6s0.2,3,1.6,3.5c11.8,4.5,19.7,15.9,19.7,28.5
		c0,16.8-13.7,30.5-30.5,30.5S12.7,70.5,12.7,53.7c0-12.6,7.9-24,19.7-28.5c1.4-0.5,2.1-2.1,1.6-3.5s-2.1-2.1-3.5-1.6
		C16.6,25.4,7.3,38.9,7.3,53.7c0,19.8,16.1,35.9,35.9,35.9s35.9-16.1,35.9-35.9C79.1,38.9,69.8,25.4,55.9,20.1z"
                      />
                      <path
                        id="XMLID_26_"
                        className="st0"
                        d="M32,44.8c0,4.2,1.8,7.3,5.5,9.5l8,4.8c1.4,0.8,2.1,2.1,2.1,3.7c0,1.2-0.4,2.3-1.2,3.2
		s-1.8,1.3-3.1,1.3h-0.2c-2,0-3.7-0.8-4.9-2.4c-0.7-0.9-1.6-1.3-2.7-1.3c-0.8,0-1.5,0.2-2.1,0.7c-0.9,0.7-1.3,1.6-1.3,2.7
		c0,0.8,0.2,1.5,0.7,2.1c2.6,3.4,6.1,5.1,10.4,5.1h0.1c2.5,0,4.7-0.8,6.7-2.2c2-1.5,3.3-3.5,4-5.9c0.3-1,0.4-2.1,0.4-3.1
		c0-4.2-1.8-7.3-5.4-9.5l-8-4.9c-1.4-0.8-2.2-2.1-2.2-3.7c0-1.2,0.4-2.3,1.2-3.1c0.8-0.9,1.8-1.3,3.1-1.3h0.2c2,0,3.7,0.8,4.9,2.5
		c0.7,0.9,1.6,1.3,2.8,1.3c0.7,0,1.4-0.2,2-0.7c0.9-0.6,1.4-1.5,1.4-2.7c0-0.7-0.2-1.4-0.7-2.1c-2.6-3.5-6.1-5.2-10.4-5.2h-0.2
		c-2.5,0-4.8,0.8-6.7,2.3c-2,1.5-3.3,3.5-4,5.9C32.1,42.7,32,43.8,32,44.8z"
                      />
                      <path
                        id="XMLID_33_"
                        className="st0"
                        d="M43.2,8.2c1.1,0,2.1-0.4,2.9-1.2s1.2-1.8,1.2-2.9c0-1.2-0.4-2.1-1.2-2.9S44.3,0,43.2,0
		s-2.1,0.4-2.9,1.2C39.5,2,39.1,3,39.1,4.1s0.4,2.1,1.2,2.9S42.1,8.2,43.2,8.2z"
                      />
                    </g>
                  </svg>
                </span>
              </h1>
              <h2 className="main--visual__subtitle">
                {/* 地球上 */}
                {/* <br className="sp" /> */}
                {/* 全人類の */}
                {/* <br className="sp" /> */}
                {/* 健康を */}
                {/* <br className="sp" /> */}
                {/* アップデート */}
                {/* <br className="sp" /> */}
                {/* させる。 */}
                Silencer Inc.
              </h2>
              <Link className="main--visual__action" to="/lemochlo">
                See Our Product →
                <span className="letterLemochlo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 168.08 36.4"
                    width="100"
                  >
                    <path d="M19.63,27.17H30.42V29.6H16.54V6.79h3.09Z" />
                    <path d="M40.32,29.93a7.16,7.16,0,0,1-5.63-2.36,8.89,8.89,0,0,1-2.09-6.12v-.69a8.71,8.71,0,0,1,2.15-6,6.65,6.65,0,0,1,5.1-2.4A6.45,6.45,0,0,1,45,14.4a8.25,8.25,0,0,1,1.75,5.52v1.93h-11l0,.07a6.62,6.62,0,0,0,1.24,4,3.92,3.92,0,0,0,3.33,1.57,7.7,7.7,0,0,0,2.75-.45,6.13,6.13,0,0,0,2-1.23l1.2,2a7.09,7.09,0,0,1-2.39,1.5A9.71,9.71,0,0,1,40.32,29.93Zm-.47-15.17a3.34,3.34,0,0,0-2.64,1.31,6,6,0,0,0-1.35,3.27l0,.08h7.82V19a4.69,4.69,0,0,0-1-3A3.45,3.45,0,0,0,39.85,14.76Z" />
                    <path d="M53,12.65l.22,2.22A5.75,5.75,0,0,1,55.34,13a6.36,6.36,0,0,1,3-.66,5.27,5.27,0,0,1,2.91.78A4.7,4.7,0,0,1,63,15.47a6.41,6.41,0,0,1,2.12-2.29,5.59,5.59,0,0,1,3.07-.84,5.09,5.09,0,0,1,4.09,1.77,8.15,8.15,0,0,1,1.5,5.35V29.6H70.73V19.43a5.61,5.61,0,0,0-.87-3.55,3.14,3.14,0,0,0-2.56-1,3.3,3.3,0,0,0-2.57,1.1,4.81,4.81,0,0,0-1.15,2.77V29.6h-3.1V19.43A5.54,5.54,0,0,0,59.6,16a3.07,3.07,0,0,0-2.55-1.11,4.31,4.31,0,0,0-2.32.58,3.77,3.77,0,0,0-1.39,1.63V29.6H50.25v-17Z" />
                    <path d="M77.57,21a9.34,9.34,0,0,1,2-6.2,6.82,6.82,0,0,1,5.53-2.43,6.93,6.93,0,0,1,5.57,2.42,9.33,9.33,0,0,1,2,6.21v.34a9.29,9.29,0,0,1-2,6.21,7.57,7.57,0,0,1-11.09,0,9.25,9.25,0,0,1-2.05-6.2Zm3.09.33a8.1,8.1,0,0,0,1.13,4.45,4.11,4.11,0,0,0,6.73,0,8,8,0,0,0,1.14-4.45V21a8,8,0,0,0-1.15-4.43,4.07,4.07,0,0,0-6.72,0A8.12,8.12,0,0,0,80.66,21Z" />
                    <path d="M103.42,27.5a4.18,4.18,0,0,0,2.7-.95,2.87,2.87,0,0,0,1.17-2.32h2.77l0,.09a4.79,4.79,0,0,1-2,3.9,7.11,7.11,0,0,1-4.72,1.71,6.89,6.89,0,0,1-5.66-2.41,9.35,9.35,0,0,1-2-6.07V20.8a9.25,9.25,0,0,1,2-6,7.72,7.72,0,0,1,10.51-.67,5.47,5.47,0,0,1,1.83,4.31l0,.09h-2.78a3.6,3.6,0,0,0-1.1-2.64,3.8,3.8,0,0,0-2.77-1.09A3.72,3.72,0,0,0,100,16.51a8.15,8.15,0,0,0-1,4.28v.65a8.29,8.29,0,0,0,1,4.33A3.74,3.74,0,0,0,103.42,27.5Z" />
                    <path d="M116.64,14.92a6.2,6.2,0,0,1,2.15-1.9,5.83,5.83,0,0,1,2.83-.68A5.47,5.47,0,0,1,125.84,14q1.51,1.62,1.51,5V29.6h-3.08V19a4.47,4.47,0,0,0-.91-3.1,3.41,3.41,0,0,0-2.68-1,4.5,4.5,0,0,0-2.33.61,5,5,0,0,0-1.71,1.63V29.6h-3.09V5.16h3.09Z" />
                    <path d="M135.12,29.6H132V5.16h3.08Z" />
                    <path d="M139.15,21a9.39,9.39,0,0,1,2-6.2,6.84,6.84,0,0,1,5.53-2.43,6.91,6.91,0,0,1,5.57,2.42,9.33,9.33,0,0,1,2,6.21v.34a9.29,9.29,0,0,1-2,6.21,7.58,7.58,0,0,1-11.1,0,9.3,9.3,0,0,1-2-6.2Zm3.08.33a8,8,0,0,0,1.14,4.45,4.11,4.11,0,0,0,6.73,0,8,8,0,0,0,1.14-4.45V21a8,8,0,0,0-1.15-4.43,3.79,3.79,0,0,0-3.38-1.77,3.71,3.71,0,0,0-3.34,1.77A8,8,0,0,0,142.23,21Z" />
                    <path d="M158.8,36.4a.59.59,0,0,1-.6-.4.62.62,0,0,1,.16-.72A23.89,23.89,0,0,0,165,18.2a23.89,23.89,0,0,0-6.64-17.08.64.64,0,0,1-.12-.72.56.56,0,0,1,.56-.4,3.46,3.46,0,0,1,2.6,1.08,23.85,23.85,0,0,1,5,7.78,25.24,25.24,0,0,1,1.72,9.34,25.24,25.24,0,0,1-1.72,9.34,23.85,23.85,0,0,1-5,7.78A3.46,3.46,0,0,1,158.8,36.4Z" />
                    <path d="M9.28,36.4a3.38,3.38,0,0,1-2.6-1.08A23.88,23.88,0,0,1,0,18.2,23.88,23.88,0,0,1,6.68,1.08,3.38,3.38,0,0,1,9.28,0a.6.6,0,0,1,.58.4.6.6,0,0,1-.14.72A23.89,23.89,0,0,0,3.08,18.2,23.89,23.89,0,0,0,9.72,35.28a.64.64,0,0,1,.12.72A.56.56,0,0,1,9.28,36.4Z" />
                  </svg>
                </span>
              </Link>
              <p className="main--visual__description">
                私たちは地球上全人類の
                <br className="sp" />
                健康アップデートをVISIONに掲げ、
                <br />
                人類が自分と向き合う為の
                <br className="sp" />
                健康革命を進めています。
              </p>
              <div className="project--circle">
                <svg viewBox="0 0 150 150">
                  <defs>
                    <path
                      id="curve"
                      d="M 75 75 m -50, 0 a 50, 50 0 1, 1 100, 0 a 50, 50 0 1, 1 -100, 0"
                    />
                  </defs>
                  <text>
                    <textPath xlinkHref="#curve">
                      Health Update for All Humans on Earth *
                    </textPath>
                  </text>
                </svg>
              </div>
            </div>
          </div>
          <EarthRotate />

          <div className="Earth2"></div>
        </section>
        <Statement />
        {/* <introProjects /> */}
        {/* <HorizontalScroll /> */}
        {/* <div className="titleProjectWrap">
        <h2 className="titleProject">Projects</h2>
      </div> */}
        {/* <HorizontalScroll__Comunity /> */}
        {/* <HorizontalScroll__Product /> */}
        {/* <HorizontalScroll__Health /> */}
        <HealthcareIntro />
        <HorizontalScroll />
        {/* <section className="lemochlo--wrap">
          <div className="lemochlo--img">
            <h2 className="lemochlo--title sp">
              サイレンサー商品第一弾。
              <br />
              健康はまず引くことから。
            </h2>
            <div className="ImageLemochlo__wrap">
              <StaticImage
                src="../images/toppage/lemochlo.png"
                alt="lemochlo"
                placeholder="blurred"
              />
            </div>
          </div>
          <div className="lemochlo--text">
            <div className="text--wrap">
              <h2 className="lemochlo--title pc">
                サイレンサー商品第一弾。
                <br />
                健康はまず引くことから。
              </h2>
              <p className="lemochlo--desc">
                この時代を生き抜く上で私たちが一生付き合うのは、家族や友人でよりも「自分自身」。
                変化に対応し、大切なもの、大切な人を守り続ける。そんなあなたの意志をレモクロはサポートします。
              </p>
              <div className="more--wrap">
                <a href="https://lemon-chlorella.com/" target="_blank">
                  レモクロの詳細を見る
                </a>
              </div>
            </div>
            <div className="cta--wrap"></div>
          </div>
        </section>
        <section className="lemochlo--wrap tampack">
          <div className="lemochlo--img tampack">
            <h2 className="lemochlo--title sp">
              第二弾は2つの味。
              <br />
              質的栄養失調と闘うプロテイン。
            </h2>
            <div className="ImageLemochlo__wrap tampack">
              <StaticImage
                src="../images/toppage/tampack.png"
                alt="lemochlo"
                placeholder="blurred"
              />
            </div>
          </div>
          <div className="lemochlo--text">
            <div className="text--wrap">
              <h2 className="lemochlo--title pc">
                第二弾は2つの味。
                <br />
                質的栄養失調と闘うプロテイン。
              </h2>
              <p className="lemochlo--desc">
                選べる味はプレーンとアサイー。栄養不足と呼ばれるほぼすべての現代人を救う本気のグラスフェッドWPIホエイプロテイン。
              </p>
              <div className="more--wrap">
                <a href="https://tampack.jp/" target="_blank">
                  TAMPACKの詳細を見る
                </a>
              </div>
            </div>
            <div className="cta--wrap"></div>
          </div>
        </section> */}
        <section className="news--wrap">
          <div className="news--box">
            <h2 className="news--tolist">News</h2>
            <BlogList data={data} />
          </div>
        </section>
        <MemberReveal />
      </div>
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query blogList {
    allWpPost(sort: { fields: [date], order: DESC }) {
      nodes {
        id
        title
        content
        slug
        date(formatString: "MMMM DD, YYYY")
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`;
